import { EventEmitter } from "@Front/Services/EventEmitter";

abstract class BaseStore {
	private _event: EventEmitter | null = null;

	protected get event(): EventEmitter {
		if (!this._event) {
			this._event = new EventEmitter();
		}
		return this._event;
	}

	public onChange<T>(callback: (params: T) => void): () => void {
		this.event.on("change", callback);
		return () => {
			this.event.off("change", callback);
		};
	}
}

// Export named only - no default export to avoid Webpack initialization order issues
// This prevents "Cannot access 'o' before initialization" errors during Next.js build
// All imports must use named import: import { BaseStore } from "@Front/Stores/BaseStore";
export { BaseStore };
